import HomeIcon from 'react-feather/dist/icons/home';
// import FolderIcon from 'react-feather/dist/icons/folder';
import InfoIcon from 'react-feather/dist/icons/info';
import BlogIcon from 'react-feather/dist/icons/book';
import MusicIcon from 'react-feather/dist/icons/music';
import ListIcon from 'react-feather/dist/icons/list';
import MicIcon from 'react-feather/dist/icons/mic';

const menu = [
  { label: 'Home', to: '/', icon: HomeIcon },
  { label: 'Blog', to: '/blog', icon: BlogIcon },
  { label: 'Listen', to: '/listen', icon: MusicIcon },
  { label: 'Songs', to: '/songs', icon: MicIcon },
  { label: 'Resources', to: '/resources', icon: ListIcon },
  { label: 'About', to: '/about', icon: InfoIcon }
];

export default menu;
